<template>
  <div class="text-center">
    <h1 class="view-title mb-12">{{ $store.state.title }}</h1>

    <v-row>
      <v-col cols="6" v-for="(item, i) in params.items" :key="item.title + i">
        <v-card class="text-center" outlined>
          <v-card-title class="justify-center">
            <h2 class="arkham text-center">
              {{ item.title }}
            </h2>
          </v-card-title>
          <v-card-text>
            <p v-if="item.lead">{{ item.lead }}</p>
            <v-btn elevation="0" color="primary" :to="item.button.to" large>
              {{ item.button.label }}
              <v-icon right v-if="item.button.icon">{{ item.button.icon }}</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['params']
}
</script>
